import { css } from '@emotion/css';
import {
    appColors,
    breakpoints,
    fontFamily,
} from '../../styles/variables.style';

import iconone from '../../assets/images/img-3928.jpeg';
import icontwo from '../../assets/images/img-3827.jpeg';

export const allChallengesFluid = css`
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 0 15px;
  position: relative;
  @media(max-width:767px){
    padding:0;
  }
  &:before {
    @media (min-width: ${breakpoints.lg.up}) {
      content: '';
      width: 100%;
      background: url(${iconone}) no-repeat 18% -22px,
        url(${icontwo}) no-repeat 83% 65%;
      padding: 50px 20px;
      position: absolute;
      top: -120px;
      height: 160px;
      z-index: -1;
    }
  }
  .newCard-add{
    .card-body{
      h4{
        max-width:140px !important;
        font-family: 'Poppins', sans-serif !important;
      }
    }
  }
  .col-md-4{
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    -webkit-flex: 0 0 33.333333%;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding: 10px 30px;
    @media (max-width: 992px) {
      padding: 10px 10px;
      @media (max-width: 767px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0 20px;
        margin-bottom: 20px;
      }
    }
    &:nth-child(01) {
      .newCard-add {
        border-color: #edc224;
        .card-body {
          h4 {
            color: ${appColors.white} !important;
          }
        }
      }
      .card-body {
        h4 {
          color: #edc224;
        }
      }
    }
    &:nth-child(03) {
      .card {
        border-color: #edc224;
        .card-body {
          h4 {
            color: #edc224;
          }
          .editevenbutton {
            background: #edc224;
          }
        }
      }
    }
    &:nth-child(04) {
      .card {
        border-color: #72ff6b;
        .card-body {
          h4 {
            color: #72ff6b;
          }
          .editevenbutton {
            background: #72ff6b;
          }
        }
      }
    }
    &:nth-child(05) {
      .card {
        border-color: #2b3cdd;
        .card-body {
          h4 {
            color: #2b3cdd;
          }
          .editevenbutton {
            background: #2b3cdd;
          }
        }
      }
    }
  }
  .card{
    width: 100%;
    box-shadow: none;
    border: 2px solid #de7028;
    border-radius: 8px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    padding: 15px;
    height: auto;
    min-height: 420px;
    @media (max-width: 992px) {
      margin-bottom: 0;
      min-height:auto;
    }
    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.28) !important;
      transition: all 0.5s;
    }
    .overflow {
      img {
        width: 100%;
        border-radius: 8px;
        object-fit: cover;
        &:hover {
          transform: scale(1);
        }
      }
      .card-body {
        width: 100%;
        max-width: 190px;
        margin: auto;
        h4 {
          padding: 0;
          margin: 10px 0;
          text-align: center;
          color: #dd6e2b;
          font-size: 18px;
          font-family: Fredoka one, sans-serif;
          font-weight: 400;
        }
        .editevenbutton {
          padding: 13px 0;
          background: #dd6e2b;
          border-radius: 8px;
          text-transform: uppercase;
          &:hover {
            background: #edc224;
            transition: all 0.5s;
          }
        }
      }
  }
`;

export const batchBanner = css`
  display: block;
  width: 100%;
  position: relative;
  padding: 0px 40px;
  @media (max-width: 767px) {
    padding: 0 20px;
  }
  h2{
    position: absolute;
    top: 7%;
    left: 50%;
    -webkit-transform: translate(-50%);
    -moz-transform: translate(-50%);
    -ms-transform: translate(-50%);
    transform: translate(-50%);
    font-size: 41px;
    color: #fff;
    font-family: Fredoka one,sans-serif;
    font-weight: 400;
    @media (max-width: 767px) {
      font-size:24px;
    }
  }
  img {
    width: 100%;
    @media (max-width: 767px) {
      height: 140px;
      object-fit: cover;
      border-radius: 8px;
    }
  }
  span {
    width: 100%;
    max-width: 330px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 767px) {
      text-align: center;
      transform: translate(-50%, -60%);
      top:60%;
    }
    img {
      width: 100%;
      max-width: 330px;
      @media (max-width: 767px) {
        max-width: 150px;
        height:auto;
      }
    }
  }
`;

export const batchTitle = css`
  text-align: center;
  padding: 50px 0;
  font-size: 36px;
  font-weight: 500;
  position: relative;
  font-family: Fredoka one, sans-serif;
  @media (max-width: 767px) {
    padding: 30px 0;
    font-size: 28px;
  }
  &:after {
    content: '';
    width: 65px;
    height: 4px;
    background: #edc224;
    position: absolute;
    left: 50%;
    bottom: 40px;
    transform: translate(-50%);
    @media (max-width: 767px) {
      bottom: 18px;
    }
  }
`;